import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Paragraph from '../../UI/Texts/Paragraph';
import { formatMoney } from '../../Common/decimalHelper';

const VisualizadorPrecioSinImpuestos = ({ 
  precioSinImpuestos, 
}) => {  
  const renderPrecioFormateado = (precio) => {
    if (precio === null || precio === undefined) return '';

    const formatted = formatMoney(precio);
    const parts = formatted.split(',');
    if (parts.length === 2 && parts[1] === '00') {
      return parts[0];
    }

    return formatted;
  };

  return (
    <div className='visualizadorPrecioSinImpuestos'>
      <Paragraph 
        sx={{
          fontSize: '10px',
          fontFamily: 'Poppins',
          fontWeight: 300,
          color: '#b0b0b0',
        }}
      >
        Precio s/imp. Nacionales {renderPrecioFormateado(precioSinImpuestos)}
      </Paragraph>
    </div>
  );
};

VisualizadorPrecioSinImpuestos.defaultProps = {
  precioSinImpuestos: 0,
};

VisualizadorPrecioSinImpuestos.propTypes = {
  precioSinImpuestos: PropTypes.number,
};

export default VisualizadorPrecioSinImpuestos;